module.exports = __webpack_public_path__ + "static/programmingsvg-e96cdf73b140747926e4f0b7ec68116a.svg";